import type { StateCreator } from 'zustand';
import triggerEventsSlice, { type TriggerEventsSliceState } from './triggerEventsSlice';
import triggerTemplateSlice, { type TriggerTemplateSliceState } from './triggerTemplateSlice';
import triggerTourSlice, { type TriggerTourSliceState } from './triggerTourSlice';

type AlertsSlices = TriggerEventsSliceState & TriggerTourSliceState & TriggerTemplateSliceState;

const alertsSlices: StateCreator<AlertsSlices, [['zustand/devtools', never]]> = (setState, getState, store) => ({
  ...triggerEventsSlice(setState, getState, store),
  ...triggerTourSlice(setState, getState, store),
  ...triggerTemplateSlice(setState, getState, store),
});

export type { AlertsSlices };
export default alertsSlices;
